import { render, staticRenderFns } from "./gj-textarea-modal.vue?vue&type=template&id=80ab0dbc&scoped=true&"
import script from "./gj-textarea-modal.vue?vue&type=script&lang=js&"
export * from "./gj-textarea-modal.vue?vue&type=script&lang=js&"
import style0 from "./gj-textarea-modal.vue?vue&type=style&index=0&id=80ab0dbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ab0dbc",
  null
  
)

export default component.exports